<template>
    <div class='bg-white w-full flex justify-center items-center'>
        <div class="warranty_box">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            
        };
    },
    components: {
        
    },
    methods: {
        
    },
};
</script>

<style lang='scss' scoped>
.warranty_box{
    width: 100%;
    max-width: var(--max-width);
    padding: 0 var(--margin-base);
    min-height: calc(100vh - 27.8125rem)
}
</style>